export default __webpack_public_path__ + "static/media/ID_8.d45cc60c.png";